// The list of acceptable admin inboxes to choose for DCV
export const AvailableEmailInboxes = [
  "admin",
  "administrator",
  "hostmaster",
  "postmaster",
  "webmaster",
];
